import { HttpClient, HttpHeaders } from '@angular/common/http';
import { inject, Injectable, signal } from '@angular/core';
import { environment } from '@environments/environment';
import { catchError, of } from 'rxjs';
import { IInforamtionAPI } from '../models';

@Injectable({
  providedIn: 'root',
})
export class MatchInformationService {
  private http = inject(HttpClient);
  private env = environment;
  private headers = new HttpHeaders({
    'Content-Type': 'application/json',
  });

  isLoadingMatchStats = signal<boolean>(false);
  isErrorMatchStats = signal<boolean>(false);
  matchinformation = signal<IInforamtionAPI | null>(null);

  constructor() {}

  getMatchInformation(matchId: String) {
    this.isLoadingMatchStats.set(true);
    this.isErrorMatchStats.set(false);

    this.http
      .get<IInforamtionAPI | null>(
        `${this.env.baseUrlWeb}/matches/${matchId}/info`,
        {
          headers: this.headers,
        }
      )
      .pipe(
        catchError((_) => {
          this.isLoadingMatchStats.set(false);
          this.isErrorMatchStats.set(true);

          return of(null);
        })
      )
      .subscribe((data) => {
        if (!data) {
          this.matchinformation.set(null);
          return;
        }

        this.matchinformation.set(data);
        this.isLoadingMatchStats.set(false);
      });
  }
}
